import { CloseOutlined } from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { useGetDeviceInfo } from "utils/useGetDeviceInfo";

import FadeIn from "./common/FadeInEffect";

import styles from "@/styles/modal.module.scss";
const WhatYouNeedData = [
  {
    id: 1,
    src: "/images/howItWork/Abstract1.png",
    title: "Personal details",
    content:
      "You will need a form of identification, such as a UK driver licence or passport.",
  },
  {
    id: 2,
    src: "/images/howItWork/Calculator.png",
    title: "Finance Details",
    content:
      "Your employment and income details to help us assess your eligibility.",
  },
  {
    id: 3,
    src: "/images/howItWork/Tick1.png",
    title: "Confirm Offer",
    content: "Review and confirm your offer to get started.",
  },
];
function HowItWorkComponent() {
  const [needModal, setNeedModal] = useState(false);

  const { deviceType, redirectUrl } = useGetDeviceInfo();

  const howItWorkContent = [
    {
      id: 1,
      src: "/images/howItWork/Wallet.png",
      alt: "Check your eligibility",
      content: (
        <p>
          Check if you are eligible, then complete the application.{" "}
          <Link
            className=" text-onmoPrimary underline"
            passHref
            href="/"
            onClick={e => {
              e.preventDefault();
              setNeedModal(true);
            }}
          >
            Here is what you will need
          </Link>
        </p>
      ),
    },
    {
      id: 2,
      src: "/images/howItWork/Tick2.png",
      alt: "Download the App",
      content: (
        <p>
          {deviceType === "ANDROID" || deviceType === "IOS" ? (
            <Link
              className="text-onmoPrimary underline"
              passHref
              href={redirectUrl}
            >
              Download the app
            </Link>
          ) : (
            <span className="text-onmoPrimary">Download the app</span>
          )}
          , confirm your details and set up a monthly direct debit.{" "}
        </p>
      ),
    },
    {
      id: 3,
      src: "/images/howItWork/Creditcard.png",
      alt: "Activate your card",
      content: <p>Activate your credit card and start using it right away! </p>,
    },
  ];

  return (
    <div className="flex flex-col md:flex-row justify-center gap-11 md:gap-spacing-14/8 3xl:gap-spacing-16.5 m-auto">
      {howItWorkContent.map(content => (
        <div className="block " key={content.id}>
          <FadeIn className="flex justify-center items-center">
            <div
              className=" w-[150px] h-[150px] 4xl:w-[320px] 4xl:h-[320px] md:w-[260px] md:h-[260px] flex justify-center items-center md:mb-6 mb-4 4xl:mb-10 bg-onmoSecondary rounded-xl content-center"
              key={content.id}
            >
              <div className="hidden md:block">
                <Image
                  src={content.src}
                  alt={content.alt}
                  width="0"
                  height="0"
                  sizes="100vw"
                  className="w-[158px] h-[158px] 4xl:w-[194px] 4xl:h-[194px] m-auto"
                />
              </div>
              <div className="md:hidden">
                <Image
                  src={content.src}
                  alt={content.alt}
                  width="0"
                  height="0"
                  sizes="100vw"
                  style={{ width: "100%", height: "auto" }}
                  className=" max-w-[90px] max-h-[90px] m-auto"
                />
              </div>
            </div>
          </FadeIn>
          <FadeIn direction="bottom">
            <div className="lg:w-[260px] 4xl:w[320px] md:text-left text-center">
              <p className="text-xl md:text-2xl 3xl:text-3xl 4xl:text-size-5 lg:mb-6 mb-4 font-ppNeue font-normal">
                Step {content.id}
              </p>
              <span className="text-sm md:text-base 3xl:text-lg 4xl:text-size-4 4xl:leading-8">
                {content.content}
              </span>
            </div>
          </FadeIn>
        </div>
      ))}
      {needModal && (
        <Modal
          open={needModal}
          onClose={() => {
            setNeedModal(false);
          }}
          disableEscapeKeyDown
          aria-labelledby="What you will need"
          aria-describedby="need-desc"
        >
          <div
            className={`${styles.modal} ${styles.noscrollbar} text-2xl text-center !min-h-[540px] overflow-y-auto md:!w-auto md:max-h-[563px] lg:h-[560px] md:!px-10 md:!py-6 text-onmoText`}
          >
            <div
              className="w-full flex justify-end md:mt-2 mb-3 md:mb-6 text-black cursor-pointer"
              onClick={() => {
                setNeedModal(false);
              }}
            >
              <CloseOutlined className="w-8 h-8" />
            </div>
            <div className="max-w-[1100px] xl:w-[1000px] px-3 pb-3 sm:pt-3 md:p-6 rounded-[20px] content-center h-[520px] sm:h-auto">
              <div className="text-3xl 3xl:text-size-5 4xl:mb-14 text-left md:text-center md:mb-11 mb-6 font-ppNeue !text-black m-auto">
                You will need <br className="md:hidden" />
                to provide:
              </div>
              <div className="flex flex-col md:flex-row justify-center gap-10 lg:gap-spacing-14 m-auto">
                {WhatYouNeedData.map(content => (
                  <div
                    className="block pb-12 sm:pb-0"
                    key={content.id}
                    id="need-desc"
                  >
                    <div
                      className="w-[140px] h-[140px] mb-6 bg-onmoSecondary rounded-xl content-center"
                      key={content.id}
                    >
                      <Image
                        src={content.src}
                        alt={content.alt}
                        width="0"
                        height="0"
                        sizes="100vw"
                        style={{ width: "100%", height: "auto" }}
                        className=" max-w-[85px] max-h-[85px] m-auto"
                      />
                    </div>

                    <div className="lg:w-[200px] text-left">
                      <p className="text-lg 3xl:text-size-4 mb-2 3xl:mb-4 font-ppNeue">
                        {content.title}
                      </p>
                      <p className="text-sm md:text-base 3xl:text-size-3 3xl:leading-6">
                        {content.content}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default HowItWorkComponent;
